import script from "./test3.vue?vue&type=script&setup=true&lang=js"
export * from "./test3.vue?vue&type=script&setup=true&lang=js"

import "./test3.vue?vue&type=style&index=0&id=07d8202e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07d8202e"]])

export default __exports__